/**
异步请求封装模块
 */
import Vue from "vue"
import axios from "axios"
import router from "../router"

//创建异步对象
const instance = axios.create({
    baseURL:'/api',
})
// 先注释了
//请求响应拦截器
instance.interceptors.request.use(request =>{
    //请求拦截器
    //获取登录用户
    const token = JSON.parse(localStorage.getItem('token'));
    if(token){
        // request.headers.Authorization = `Bearer ${token}`
        request.headers.token = token
    }
    return request
})
//响应拦截器
instance.interceptors.response.use(response=>{
    if(response.status === 401){
        return response
    }
    else if(response.data.code === 213){
        router.push('/login')
        return response.data
    }
    else if(response.data.code === 200 || response.data.code === 201){
        return response.data
    }
    else{
        return response
    }
})

//挂载到vue原型上使用
//Vue组件，，可以通过this.$axios.get(...)发送请求
Vue.prototype.axios = instance

export default instance